import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';
import { ImageComponent } from '../../atoms/image/image.component';
import { RegexTypes } from '../../../utils/regex-types';
import { ThemeService } from '../../../infrastructure/theme/theme.service';

@Component({
  selector: 'app-landlord-info',
  templateUrl: './landlord-info.component.html',
  styleUrls: ['./landlord-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ImageComponent, TranslatePipe]
})
export class LandlordInfoComponent {
  private themeService = inject(ThemeService);

  readonly name = input<string>();
  readonly logo = input<string>();
  readonly logoRedirectUrl = input<string>();
  readonly showOfferedBy = input(true);
  readonly offeredByTitle = input<string>();
  readonly showInCooperationWith = input(true);

  public baseClass = 'landlord-info';

  public get withLinkedLogo(): boolean {
    return !!RegexTypes.URL.exec(this.logoRedirectUrl());
  }

  public get showInCooperationWithImmomio(): boolean {
    return !!this.logo();
  }

  public get customerLogo(): string {
    return (
      this.logo() ||
      this.themeService?.getTheme(this.themeService?.getDefaultTheme)?.logo?.url
    );
  }
}
